/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import { TypeDateNaissance } from '@/enums';
import {
  Exemption,
  type Individu,
  ListeRecensement,
  Pupille,
  SituationFamiliale,
} from '@/types';

const DEFAULT_INDIVIDU: Individu = {
  identifiant: null,
  identifiantEntite: null,
  identifiantCivilite: null,
  identifiantAdresseNaissance: null,
  identifiantAdresseRattachement: null,
  identifiantAdresseContact: null,
  identifiantSituationScolaire: null,
  identifiantDiplome: null,
  identifiantProfession: null,
  identifiantSpecialite: null,
  identifiantParent1: null,
  identifiantParent2: null,
  identifiantPecoto: null,
  // Utilisé pour les parents
  identifiantNationalite: null,
  identifiantNationaliteBis: null,
  hasDoubleNationalite: false,
  scolarise: null,
  activiteProfessionnelle: null,
  isBrouillon: false,
  sexe: null,
  situationFamiliale: SituationFamiliale.Celibataire,
  nomFamille: '',
  nomUsage: '',
  prenom: '',
  prenomsComplementaires: '',
  nombreFreresSoeurs: 0,
  nombreEnfants: 0,
  anneeNaissance: null,
  moisNaissance: null,
  jourNaissance: null,
  heureNaissance: null,
  minuteNaissance: null,
  typeDateNaissance: TypeDateNaissance.COMPLET,
  recensement: ListeRecensement.NonRecenses,
  trimestreRecensement: 1,
  anneeRecensement: 2000,
  dateRecensement: '',
  numeroRecensement: 0,
  demandeExemption: Exemption.SansObjet,
  exemptionActive: false,
  isResideCommune: true,
  tel1: '',
  tel2: '',
  mail: '',
  pupille: Pupille.Non,
  filiationInconnueParent1: false,
  filiationInconnueParent2: false,
  // Les attributs ne sont pas récupérés de la base de données
  adresseNaissance: {},
  adresseRattachement: {},
  adresseContact: {
    type: 'Commune',
  },
  parent1: {},
  parent2: {},
  // Ces champs sont utiles pour la step 4
  situationScolaire: {},
  diplome: {},
  specialite: {},
  profession: {},
};

export default DEFAULT_INDIVIDU;
